/* eslint-disable react/jsx-props-no-spreading,jsx-a11y/mouse-events-have-key-events */
import { MarkerProps } from "@vis.gl/react-maplibre";
import React from "react";
import { Marker } from "./BaseMap";
import styles from "./style.module.scss";

interface BaseMarkerProps
  extends MarkerProps,
    Omit<
      React.DOMAttributes<HTMLDivElement>,
      "onClick" | "onDragStart" | "onDragEnd" | "onDrag"
    > {
  id?: string;
  className?: string;
}

function BaseMarker({
  children,
  id,
  className,
  onMouseEnter,
  onMouseOver,
  onMouseLeave,
  onMouseMove,
  ...restProps
}: BaseMarkerProps) {
  return (
    <Marker anchor="bottom" pitchAlignment="viewport" {...restProps}>
      <div
        id={id}
        className={`${styles.mapMarker} ${styles.defaultMapMarker} ${className}`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseOver={onMouseOver}
        onMouseMove={onMouseMove}
      >
        {children}
      </div>
    </Marker>
  );
}

export default BaseMarker;
